module.exports = __webpack_public_path__ + "img/placeholder.27426775.svg";